export const ANDROID_DOWNLOAD_URL =
  "https://play.google.com/store/apps/details?id=com.ministrycentered.churchcenter"

export const IOS_DOWNLOAD_URL =
  "https://apps.apple.com/us/app/church-center-app/id1357742931"
